import { styled } from "@mui/material/styles";
import Slider from "@mui/material/Slider";

export const SliderPlayer = styled(Slider)((/*{ theme }*/) => ({
  root: {
    bgcolor: 'background.medium'
  },
  "& .MuiSlider-thumb": {
    transition: 'none',
    width: 10,
    height: 10,
  },
  "& .MuiSlider-track": {
    transition: 'none',
    bgcolor: 'background.medium'
  },
}))

/*export const SliderPlayer = styled(Slider)((/!*{ theme }*!/) => ({
  "& .MuiSlider-thumb": {
    transition: 'left 0.1s'
  },
  "& .MuiSlider-thumb.MuiSlider-active": {
    transition: 'left 0'
  },
  "& .MuiSlider-track": {
    transition: 'width 0.1s'
  },
}))*/
